import * as React from 'react';
import {compose} from 'redux';
import {withStyles} from '@material-ui/core/styles';
import LogBox from '../../core/logger/LogBox';
import {ApplicationState} from "../../store";
import {connect} from "react-redux";
import Button from '@material-ui/core/Button';
import {CssBaseline, CircularProgress, TextField, FormControl, Link, FormHelperText} from '@material-ui/core';
import TabView from "../../tabs/TabView";
import {TabsService} from "../../tabs/TabsService";
import {TabTypes} from "../../tabs/Tab";
import {LoggerService} from "../../core/logger/LoggerService";
import {GlobalStyles} from "../../materialui/style";
import MainMenu from "../../layout/MainMenu";
import ApplicationBar from "../../layout/ApplicationBar";
import {AppCookies} from "../../core/Cookies";
import {
	actionUserForgotPasswordRequestReset,
	actionUserForgotPasswordRequest,
	actionUserLogin,
	actionUserSetAccessToken
} from "../../store/global";
import {AppConfig} from "../../config";
import {PopupDialog} from "../../core/components/PopupDialog";
import {t} from "../../core/localization";
import {DocumentTypes} from "../../models/Document";
import * as queryString from "querystring";
import {actionNotificationDelete, actionNotificationMarkSeen} from "../../store/notifications";

console.log(process.env.NODE_ENV)

export interface MainDesktopProps {
	loading: number,
	classes: any,
	accessToken: string,
	loginError: boolean,
	forgotPasswordError: boolean
	forgotPasswordCompleted: boolean
	match: any
	location: any
}

export interface MainDesktopState {
	username: string,
	password: string,
	loginView: boolean,
	loginError: boolean,
	loginErrorMessage: string,
	forgotPasswordEmail: string,
	forgotPasswordEmailError: boolean,
	forgotPasswordEmailErrorMessage: string
}

function mapStateToProps(state: ApplicationState) {
	return {
		loading: state.global.loading,
		accessToken: state.global.accessToken,
		loginError: state.global.loginError,
		forgotPasswordError: state.global.forgotPasswordError,
		forgotPasswordCompleted: state.global.forgotPasswordCompleted
	};
}

class MainDesktop extends React.Component<MainDesktopProps, MainDesktopState> {

	constructor(props: MainDesktopProps) {
		super(props);
		this.state = {
			username: 'office@normasoft.net',
			password: '',
			loginView: true,
			loginError: false,
			loginErrorMessage: '',
			forgotPasswordEmail: '',
			forgotPasswordEmailError: false,
			forgotPasswordEmailErrorMessage: ''
		}
	}

	componentDidMount () {
		this.loadData();
		this.setLoginErrorStatus();
		if (this.props.match.params.documentId) {
			const type = TabTypes.DOCUMENT_NEW
			TabsService.createTab(type.defaultTitle(), type, {id: this.props.match.params.documentId })
		}
		if (this.props.location.search) {
			const params = queryString.parse(this.props.location.search.replace("?", ""))
			if (params.nId) {
				actionNotificationMarkSeen(params.nId as string)
			}
		}
	}

	componentDidUpdate(prevProps: Readonly<MainDesktopProps>, prevState: Readonly<MainDesktopState>, snapshot?: any): void {

		if(this.props.loginError !== prevProps.loginError) {
			this.setLoginErrorStatus();
		}

		if(this.props.forgotPasswordError !== prevProps.forgotPasswordError) {
			if(this.props.forgotPasswordError && this.props.forgotPasswordCompleted) {

				let errorMessage = this.state.forgotPasswordEmail === '' ? t.RequiredField : t.NonExistentEmail;
				this.setState({
					forgotPasswordEmailError: this.props.forgotPasswordError,
					forgotPasswordEmailErrorMessage: errorMessage
				})
			}
		}
	}

	render(): React.ReactNode {

		let classes = this.props.classes
		return (
			<div className="desktop-app">
				{AppConfig().logging && <LogBox />}
				{(this.props.loading > 0) &&
				<div className="opacityOverlay">
				<div className="loadingOverlay">
					<CircularProgress />
				</div></div>}
				{this.renderContent(classes)}
			</div>
		);
	}

	renderContent(classes: any) {
		if (this.isLogged()) return this.renderApplication(classes);
		else {
			return this.state.loginView ? this.renderLogin(classes) : this.renderForgotPassword(classes);
		}
	}

	renderApplication (classes: any): React.ReactNode {
		return <>
			<CssBaseline />
			<ApplicationBar />
			<MainMenu />
			<main className={classes.content + ' main-content'}>
				<div className={classes.appBarSpacer} />
				<div className={classes.tableContainer}>
					<TabView/>
				</div>
			</main>
		</>
	}

	renderLogin (classes: any): React.ReactNode {
		return <div className={'ev-login'} style={{position: 'fixed', top: '30%', left: '25%', width: '50%'}}>
			<FormControl style={{width: '100%'}}>
				<TextField
					label="Email"
					value={this.state.username}
					onChange={(e) => {this.setState({...this.state, username: e.target.value})}}
					margin="normal"
					fullWidth
					required={true}
					error={this.state.loginError}
				/>
				<TextField
					label="Password"
					onChange={(e) => {this.setState({...this.state, password: e.target.value})}}
					value={this.state.password}
					margin="normal"
					type='password'
					fullWidth
					required={true}
					error={this.state.loginError}
				/>
				{this.state.loginError && <FormHelperText style={{color: '#ed1a3a'}}>{this.state.loginErrorMessage}</FormHelperText>}
			</FormControl>
			<Button onClick={this.onLoginClick.bind(this)} variant="contained" color="primary" style={{marginTop: '20px'}}>Login</Button>
			<div style={{marginTop: "20px"}}><Link onClick={this.toggleFormsHandler.bind(this)}>{t.ForgotPassword}</Link></div>
		</div>
	}

	renderForgotPassword(classes: any): React.ReactNode {
		return <div className={'ev-login'} style={{position: 'fixed', top: '30%', left: '25%', width: '50%'}}>
			<h1 style={{color: '#ed1a3a'}}>{t.PleaseEnterYourEmail}</h1>
			<FormControl style={{width: '100%'}}>
				<TextField
					label="Email"
					value={this.state.forgotPasswordEmail}
					onChange={(e) => {this.setState({...this.state, forgotPasswordEmail: e.target.value})}}
					margin="normal"
					fullWidth
					required={true}
					error={this.state.forgotPasswordEmailError}
				/>
				{this.state.forgotPasswordEmailError && <FormHelperText style={{color: '#ed1a3a'}}>{this.state.forgotPasswordEmailErrorMessage}</FormHelperText>}
			</FormControl>
			<Button onClick={this.onForgotPasswordClick.bind(this)} variant="contained" color="primary" style={{marginTop: '20px'}}>{t.Send}</Button>
			<div style={{marginTop: "20px"}}><Link onClick={this.toggleFormsHandler.bind(this)}>{t.BackToLogin}</Link></div>
			<PopupDialog
				isOpen={this.props.forgotPasswordCompleted && !this.props.forgotPasswordError}
				title={t.Success}
				text={t.ResetPasswordLinkMessage}
				onClose={this.onForgotPasswordConfirmDialogClose.bind(this)} />
		</div>
	}

	onLoginClick () {

		let {username, password} = this.state;

		if(username === '' || password === '') {
			this.setState({loginError: true, loginErrorMessage: t.RequiredFields})
			return
		}

		actionUserLogin(username, password)
	}

	toggleFormsHandler() {
		this.setState({ loginView: !this.state.loginView })
	}

	onForgotPasswordClick() {

		if(this.state.forgotPasswordEmail !== '') {

			actionUserForgotPasswordRequest(this.state.forgotPasswordEmail)
		}
		else {
			this.setState({forgotPasswordEmailError: true, forgotPasswordEmailErrorMessage: t.RequiredField})
		}
	}

	onForgotPasswordConfirmDialogClose() {
		actionUserForgotPasswordRequestReset()
		this.setState({forgotPasswordEmail: '', forgotPasswordEmailError: false, forgotPasswordEmailErrorMessage: '', loginView: true})
	}

	private isLogged(): boolean {
		let accessToken = AppCookies.getAccessToken()
		if (accessToken) return true
		if (this.props.accessToken && this.props.accessToken != '') return true
		return false
	}

	loadData () {
		let accessToken = AppCookies.getAccessToken()
		actionUserSetAccessToken(accessToken)
	}

	setLoginErrorStatus() {

		if(this.props.loginError) {

			let loginErrorMessage = this.state.username === '' || this.state.password === '' ? t.RequiredFields : t.WrongEmailOrPassword;
			this.setState({loginError: true, loginErrorMessage: loginErrorMessage})
		}
		else{
			this.setState({loginError: false, loginErrorMessage: '', password: ''})
		}
	}
}

export default compose(
	withStyles(GlobalStyles),
	connect(mapStateToProps)
)(MainDesktop);
